import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, ChevronDown, ChevronUp } from "lucide-react";
import { useSupportNotifications } from "@/lib/SupportNotificationsContext";
import { ProductStatus } from "@/components/ProductStatus";

export const SupportNotificationCenter = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { items, unread, markTicketRead } = useSupportNotifications();

  const openNotice = async notice => {
    try { await markTicketRead(notice.ticket_id); } catch { /* The ticket is still accessible. */ }
    navigate(notice.url);
  };

  return (
    <section className="border-y border-[#E5E5E0] py-4" data-testid="support-notifications">
      <button type="button" onClick={() => setOpen(value => !value)}
              className="w-full flex items-center justify-between text-left gap-3 text-sm"
              aria-expanded={open} data-testid="support-notifications-toggle">
        <span className="inline-flex items-center gap-2"><Bell className="w-4 h-4" />Notifiche
          {unread > 0 && <ProductStatus tone="warning" testId="support-notifications-unread">{unread} da leggere</ProductStatus>}
        </span>
        {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>
      {open && (
        <div className="mt-4 max-h-64 overflow-y-auto divide-y divide-[#E5E5E0]" data-testid="support-notifications-list">
          {items.length === 0 && <p className="text-sm text-[#707070] py-3" data-testid="support-notifications-empty">Nessuna notifica.</p>}
          {items.map(item => (
            <button type="button" key={item.id} onClick={() => openNotice(item)}
                    className={`block w-full text-left px-3 py-3 hover:bg-[#F4F4F0] ${item.is_read ? "text-[#707070]" : "support-ux-notification-unread border-l-2"}`}
                    data-testid={`support-notification-${item.id}`}>
              <span className="block font-medium text-sm">{item.title}</span>
              <span className="block text-xs mt-1">{item.body}</span>
            </button>
          ))}
        </div>
      )}
    </section>
  );
};